import * as React from 'react'

import { styled } from '~/styled'
import { Override } from '~/utilities/types'

export const StyledIcon = styled(
  'svg',
  {
    base: [
      'inline-block',
      'fill-none',
      'shrink-0',
      'stroke-current',
      '[stroke-linecap:round]',
      '[stroke-linejoin:round]',
      'align-middle'
    ],
    variants: {
      size: {
        sm: ['size-4', 'stroke-[1.5]'],
        md: ['size-6', 'stroke-[1.75]'],
        lg: ['size-8', 'stroke-2']
      }
    }
  },
  { enabledResponsiveVariants: true }
)

type IconProps = Override<
  React.ComponentProps<typeof StyledIcon>,
  {
    is: React.FC<React.SVGProps<SVGSVGElement>>
    as?: never
  }
>

export const Icon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ is: SVG, size = 'md', ...remainingProps }, ref) => (
    <StyledIcon
      size={size}
      aria-hidden="true"
      {...remainingProps}
      as={SVG}
      ref={ref}
    />
  )
)
